
import UploadPropositionDocComponent from "../../components/upload/UploadPropositionDocComponent";
import { IDocumentType } from "../../context/model";

type UploadPropositionDocBlocProps = {
  token: string;
  propositionId: string;
  docType: IDocumentType;
  eventId: string;
  docId: string;
}
export default function UploadPropositionDocBloc({token, propositionId, docType, eventId, docId} : Readonly<UploadPropositionDocBlocProps>) {

      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Votre {docType?.label}</h2>
              <UploadPropositionDocComponent token={token} propositionId={propositionId} docType ={docType} eventId={eventId} docId={docId}/>
            </div>
        </div>
      )
}